import { render } from "./EditLoaderModal.vue?vue&type=template&id=3972b624&scoped=true"
import script from "./EditLoaderModal.vue?vue&type=script&lang=js"
export * from "./EditLoaderModal.vue?vue&type=script&lang=js"

import "./EditLoaderModal.vue?vue&type=style&index=0&id=3972b624&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3972b624"]])

export default __exports__